import { Link } from "react-router-dom";
import { LegalLayout, H2, H3, P, List, Note } from "./LegalLayout";

export default function Community() {
  return (
    <LegalLayout
      title="FOUND Community Guidelines"
      description="FOUND is a music-first platform. Learn what belongs on FOUND and how content is moderated."
    >
      <P>
        FOUND is a <strong>music-first</strong> platform for discovering emerging Artists. These
        Guidelines keep FOUND focused, fair and safe. They apply to all content and accounts,
        including Artists, Scouts, uploads, comments and Scout Posts.
      </P>

      <H2>What belongs on FOUND</H2>
      <List items={[
        "Original songs",
        "Music videos",
        "Live performances",
        "Acoustic performances",
        "Studio performances",
        "Song previews",
        "Music creation content",
        "Scout recommendations about Artists and music",
        "Other content directly relevant to music discovery",
      ]} />

      <H2>What is not allowed</H2>
      <List items={[
        "Unrelated memes, generic gaming videos or unrelated lifestyle videos",
        "Non-music viral spam",
        "Copyright infringement or stolen music",
        "Fake Artists or impersonation",
        "Harassment, hate or abusive behaviour",
        "Spam, fraud and bots",
        "Artificial engagement or coordinated manipulation",
        "Attempts to manipulate Scout Points or rankings",
        "Other illegal or seriously harmful content",
      ]} />

      <H2>Reporting content</H2>
      <P>You can report content or accounts using these categories:</P>
      <List items={[
        "Not Music",
        "Copyright",
        "Spam",
        "Harassment",
        "Explicit / Inappropriate Content",
        "Fake Artist / Impersonation",
        "Other",
      ]} />
      <P>
        To report something, use the in-app report option or the{" "}
        <Link to="/found/support" className="text-white underline">FOUND Support</Link> page. Copyright
        owners should also see the <Link to="/found/copyright" className="text-white underline">Copyright & IP Policy</Link>.
      </P>

      <H2>How content is reviewed</H2>
      <P>Content on FOUND may move through the following states:</P>
      <List items={[
        "Pending — awaiting review",
        "Approved — visible on FOUND",
        "Flagged — under review or limited",
        "Removed — taken down for violating these Guidelines or our Terms",
      ]} />
      <Note>
        {`Dream Big Entertainment Ltd may moderate content and accounts — including removing content and suspending or terminating accounts — to protect the FOUND community and comply with the law.`}
      </Note>
    </LegalLayout>
  );
}
